import React, { Component } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import {
  PageHeader,
  CustomPanel,
  CustomCheckbox,
  Loading,
  ThreeDots,
  CustomDataTableHeader,
} from '../../../../components'
import ModalUsuarioTP from './ModalUsuarioTP/ModalUsuarioTP'
import ModalUsuarioGrupo from './ModalUsuarioGrupo/ModalUsuarioGrupo'
import ModalUsuarioEmpresa from './ModalUsuarioEmpresa/ModalUsuarioEmpresa'
import ModalUsuarioCentralOperacoes from './ModalUsuarioCentralOperacoes/ModalUsuarioCentralOperacoes'
import { showMessageBox } from '../../../../store/actions/system.actions'
import * as UsuarioHttp from '../../../../services/api/https/settings/user.http'
import ModalUsuarioPatrimonioOwner from './ModalUsuarioPatrimonioOwner/ModalUsuarioPatrimonioOwner'
import ModalUsuarioCompaniesGroup from './ModalUsuarioCompaniesGroup/ModalUsuarioCompaniesGroup'
import ModalEditarUsuario from './ModalEditarUsuario/ModalEditarUsuario'

class Usuario extends Component {
  state = {
    isLoanding: true,
    usuarios: [],
    idUsuarioSelecionado: null,
    usuarioSelecionado: null,
    showModalUsuarioTPs: false,
    showModalUsuarioGrupos: false,
    showModalUsuarioEmpresas: false,
    showModalCentralOperacoes: false,
    showModalLocalMovimentacao: false,
    showModalPatrimonioOwner: false,
    showModalCompaniesGroup: false,
    showModalEditarUsuario: false,
    globalFilter: '',
  }
  onBtnVoltar = () => {
    this.props.history.goBack()
  }
  onToggleAtivo = async usuario => {
    try {
      const updatedUsuario = await UsuarioHttp.userToggleActived(usuario.id)
      this._updateUsuarios(updatedUsuario)
    } catch (error) {
      this.props.dispatch(showMessageBox(null, error))
    }
  }
  onThreeDotsClicked = (menuItem, usuario) => {
    const { id } = usuario
    switch (String(menuItem)) {
      case 'Grupos de Usuários':
        this.setState({ showModalUsuarioGrupos: true, idUsuarioSelecionado: id })
        break
      case 'Empresas':
        this.setState({ showModalUsuarioEmpresas: true, idUsuarioSelecionado: id })
        break
      case 'Operadores Logísticos':
        this.setState({ showModalUsuarioTPs: true, idUsuarioSelecionado: id })
        break
      case 'Central de Operações':
        this.setState({ showModalCentralOperacoes: true, idUsuarioSelecionado: id })
        break
      case 'Patrimônio Owner':
        this.setState({ showModalPatrimonioOwner: true, idUsuarioSelecionado: id })
        break
      case 'Grupo de Empresas':
        this.setState({ showModalCompaniesGroup: true, idUsuarioSelecionado: id })
        break
      case 'Editar Usuário':
        this.setState({ showModalEditarUsuario: true, usuarioSelecionado: usuario })
        break
      default:
        console.error('Opção do Menu não identificada !')
        break
    }
  }
  onModalClose = showModalName => {
    this.setState(state => {
      state[showModalName] = false
      return state
    })
  }
  onModalEditarUsuarioSave = usuario => {
    this._updateUsuarios(usuario)
    this.setState({ showModalEditarUsuario: false })
  }
  componentDidMount = async () => {
    try {
      const usuarios = await UsuarioHttp.getUsers()
      this.setState({ isLoanding: false, usuarios })
    } catch (error) {
      this.props.dispatch(showMessageBox(null, error))
    }
  }

  render() {
    const {
      isLoanding,
      showModalUsuarioEmpresas,
      showModalUsuarioGrupos,
      showModalUsuarioTPs,
      showModalCentralOperacoes,
      showModalPatrimonioOwner,
      showModalCompaniesGroup,
      showModalEditarUsuario,
    } = this.state
    return (
      <div>
        <PageHeader>S.3 - Gestão de Usuários</PageHeader>
        <div style={{ marginTop: 20 }}>
          <CustomPanel showBtnNovo={false} onVoltar={this.onBtnVoltar}>
            {isLoanding ? (
              <div className="text-center">
                <Loading size="md" />
              </div>
            ) : (
              this._dataTable()
            )}
          </CustomPanel>
        </div>
        {showModalUsuarioTPs ? this._getModalUsuarioTPs() : null}
        {showModalUsuarioGrupos ? this._getModalUsuarioGrupos() : null}
        {showModalUsuarioEmpresas ? this._getModalUsuarioEmpresas() : null}
        {showModalCentralOperacoes ? this._getModalUsuarioCentralOperacoes() : null}
        {showModalPatrimonioOwner ? this._getModalUsuarioPatrimonioOwner() : null}
        {showModalCompaniesGroup ? this._getModalUsuarioCompaniesGroup() : null}
        {showModalEditarUsuario ? this._getModalEditarUsuario() : null}
      </div>
    )
  }

  _dataTable = () => {
    return (
      <DataTable
        value={this.state.usuarios}
        rows={10}
        paginator
        globalFilter={this.state.globalFilter}
        header={
          <CustomDataTableHeader onChange={value => this.setState({ globalFilter: value })} />
        }
      >
        <Column field="id" header="Código" style={{ textAlign: 'center', width: 80 }} />
        <Column field="name" header="Usuário" />
        <Column field="email" header="E-mail" />
        <Column
          field="actived"
          header="Ativo"
          style={{ textAlign: 'center', width: 100 }}
          body={(rowData, column) => (
            <CustomCheckbox
              checked={rowData.actived}
              onChange={() => this.onToggleAtivo(rowData)}
            />
          )}
        />
        <Column
          header="Menu"
          style={{ textAlign: 'center', width: 80 }}
          body={(rowData, column) => (
            <ThreeDots
              items={this._getMenuItems()}
              onClick={menuItem => this.onThreeDotsClicked(menuItem, rowData)}
            />
          )}
        />
      </DataTable>
    )
  }
  _updateUsuarios = usuario => {
    this.setState(state => {
      const { usuarios } = state
      const index = usuarios.findIndex(l => l.id === usuario.id)
      index !== -1 ? (usuarios[index] = usuario) : usuarios.push(usuario)
      return { usuarios }
    })
  }

  _getMenuItems() {
    return [
      'Grupos de Usuários',
      'Empresas',
      'Operadores Logísticos',
      'Central de Operações',
      'Patrimônio Owner',
      'Grupo de Empresas',
      'Editar Usuário',
    ]
  }

  _getModalUsuarioTPs = () => {
    const { showModalUsuarioTPs, idUsuarioSelecionado } = this.state
    return (
      <ModalUsuarioTP
        userId={idUsuarioSelecionado}
        show={showModalUsuarioTPs}
        onClose={this.onModalClose}
      />
    )
  }
  _getModalUsuarioGrupos = () => {
    const { showModalUsuarioGrupos, idUsuarioSelecionado } = this.state
    return (
      <ModalUsuarioGrupo
        userId={idUsuarioSelecionado}
        show={showModalUsuarioGrupos}
        onClose={this.onModalClose}
      />
    )
  }
  _getModalUsuarioEmpresas = () => {
    const { showModalUsuarioEmpresas, idUsuarioSelecionado } = this.state
    return (
      <ModalUsuarioEmpresa
        userId={idUsuarioSelecionado}
        show={showModalUsuarioEmpresas}
        onClose={this.onModalClose}
      />
    )
  }
  _getModalUsuarioCentralOperacoes = () => {
    const { showModalCentralOperacoes, idUsuarioSelecionado } = this.state
    return (
      <ModalUsuarioCentralOperacoes
        userId={idUsuarioSelecionado}
        show={showModalCentralOperacoes}
        onClose={this.onModalClose}
      />
    )
  }
  _getModalUsuarioPatrimonioOwner = () => {
    const { showModalPatrimonioOwner, idUsuarioSelecionado } = this.state
    return (
      <ModalUsuarioPatrimonioOwner
        userId={idUsuarioSelecionado}
        show={showModalPatrimonioOwner}
        onClose={this.onModalClose}
      />
    )
  }
  _getModalUsuarioCompaniesGroup = () => {
    const { showModalCompaniesGroup, idUsuarioSelecionado } = this.state
    return (
      <ModalUsuarioCompaniesGroup
        userId={idUsuarioSelecionado}
        show={showModalCompaniesGroup}
        onClose={this.onModalClose}
      />
    )
  }
  _getModalEditarUsuario = () => {
    const { showModalEditarUsuario, usuarioSelecionado } = this.state
    return (
      <ModalEditarUsuario
        usuario={usuarioSelecionado}
        show={showModalEditarUsuario}
        onModalClose={() => this.setState({ showModalEditarUsuario: false })}
        onModalSave={this.onModalEditarUsuarioSave}
      />
    )
  }
}

export default connect()(withRouter(Usuario))
